import React from 'react';
import ChecklistElement from './ChecklistElementModel';
import EditorType from '../../../Enums/EditorType';
import type { JSX } from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import type { SelectChangeEvent } from '@mui/material/Select';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import type Category from '../../CategoryModel';

class CategoryChecklistElement extends ChecklistElement {

    private _parentCategoryId: string;

    public constructor(elementId: string, name: string, itemNumber: string | null, sortNumber: number, parentCategoryId: string) {

        super(elementId, name, itemNumber, sortNumber, EditorType.CATEGORY);
        this._parentCategoryId = parentCategoryId;
    }

    public get parentCategoryId(): string {
        return this._parentCategoryId;
    }

    public set parentCategoryId(value: string) {
        this._parentCategoryId = value;
    }

    public buildFormElement(value: string, onChange: (value: string) => Promise<void>, currentCategories: Category[], categoryMenuItems: JSX.Element[], screenWidth: number): JSX.Element {

        return (
            <React.Fragment key={this.elementId}>
                <FormControl 
                    size='small'
                    style={{
                        width: Math.min(screenWidth * 0.8, 500),
                    }}
                >
                    <InputLabel>{this.name}</InputLabel>
                    <Select
                        value={value}
                        onChange={async (e: SelectChangeEvent): Promise<void> => onChange((e.target as HTMLInputElement).value)}
                        size='small'
                        variant='outlined'
                        label={this.name}
                    >
                        <MenuItem 
                            key='__empty__'
                            value=''
                        >
                            &nbsp;
                        </MenuItem>
                        {value !== '' && !currentCategories.map((category: Category) => category.categoryId.toString()).includes(value) && //allows removed options to still be there until changed
                            <MenuItem 
                                key='__current__'
                                value={value}
                                disabled={true}
                            >
                                {value}
                            </MenuItem>
                        }
                        {categoryMenuItems}
                    </Select>
                </FormControl>
                <br />
                <br />
            </React.Fragment>
        );
    }
}

export default CategoryChecklistElement;